var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_122686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 5.83329H6.25008C5.69755 5.83329 5.16764 5.6138 4.77694 5.2231C4.38624 4.8324 4.16675 4.30249 4.16675 3.74996C4.16675 3.19742 4.38624 2.66752 4.77694 2.27682C5.16764 1.88612 5.69755 1.66663 6.25008 1.66663C9.16675 1.66663 10.0001 5.83329 10.0001 5.83329ZM10.0001 5.83329H13.7501C14.3026 5.83329 14.8325 5.6138 15.2232 5.2231C15.6139 4.8324 15.8334 4.30249 15.8334 3.74996C15.8334 3.19742 15.6139 2.66752 15.2232 2.27682C14.8325 1.88612 14.3026 1.66663 13.7501 1.66663C10.8334 1.66663 10.0001 5.83329 10.0001 5.83329ZM10.0001 5.83329L10.0001 18.3333M1.66675 11.6666H18.3334M1.66675 8.49996L1.66675 15.6666C1.66675 16.6 1.66675 17.0668 1.8484 17.4233C2.00819 17.7369 2.26316 17.9918 2.57676 18.1516C2.93328 18.3333 3.39999 18.3333 4.33341 18.3333L15.6667 18.3333C16.6002 18.3333 17.0669 18.3333 17.4234 18.1516C17.737 17.9918 17.992 17.7369 18.1518 17.4233C18.3334 17.0668 18.3334 16.6 18.3334 15.6666V8.49996C18.3334 7.56654 18.3334 7.09983 18.1518 6.74331C17.992 6.42971 17.737 6.17474 17.4234 6.01495C17.0669 5.83329 16.6002 5.83329 15.6667 5.83329L4.33342 5.83329C3.39999 5.83329 2.93328 5.83329 2.57676 6.01495C2.26316 6.17474 2.00819 6.4297 1.8484 6.74331C1.66675 7.09983 1.66675 7.56654 1.66675 8.49996Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_122686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift3);
export default __webpack_public_path__ + "static/media/gift3.1e2b6a82b17b53d9a19fef10d23e0218.svg";
export { ForwardRef as ReactComponent };